var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { TemplateRef, ChangeDetectorRef, QueryList } from '@angular/core';
import { MatDialog, MatSnackBar, MatDialogConfig } from '@angular/material';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatNumber } from '@angular/common';
import { startWith, map } from 'rxjs/operators';
import { RutValidator } from 'ng2-rut';
import { PropiedadService } from 'src/app/services/propiedad.service';
import { PerfilComponent } from '../perfil/perfil.component';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { GLOBAL } from 'src/app/services/global';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
var Solicitud_certificadosComponent = /** @class */ (function () {
    function Solicitud_certificadosComponent(dialog, _prop, _formBuilder, _userService, snackBar, spinner, _changeDetector, rutValidator, _router, store, claveUnicaService) {
        var _this = this;
        this.dialog = dialog;
        this._prop = _prop;
        this._formBuilder = _formBuilder;
        this._userService = _userService;
        this.snackBar = snackBar;
        this.spinner = spinner;
        this._changeDetector = _changeDetector;
        this.rutValidator = rutValidator;
        this._router = _router;
        this.store = store;
        this.claveUnicaService = claveUnicaService;
        this.global = GLOBAL;
        this.isLinear = true;
        this.displayedColumns = ['rol', 'direccion', 'actions'];
        this.btnDisabled = true;
        this.continuar = false;
        //calculo valores certificados
        this.valores_cert = [];
        this.valores_cert_noformat = [];
        this.valorOnlyCert = 0;
        this.valorTotalEstampilla = 0;
        this.certSelected = [];
        this.valor_total_cert = 0;
        this.cert = [];
        //forms
        this.rut = new FormControl('');
        this.rol = new FormControl('');
        this.dir = new FormControl('');
        this.num = new FormControl('');
        this.correo = new FormControl('');
        this.nombre = new FormControl('');
        this.telefono = new FormControl('');
        this.url_fracaso = new FormControl('');
        this.url_exito = new FormControl('');
        this.numAsig = [1, 1, 1];
        this.observacion = new FormControl('');
        this.mostrarNum = false;
        //direcciones agregadas
        this.lista_dir = new BehaviorSubject([]);
        this.dirs = [];
        //banderapago
        this.pagando = false;
        //banderas
        this.mostrar_solicitud = false;
        this.primerPaso = false;
        this.segundoPaso = false;
        this.tercerPaso = false;
        this.primerPaso_mod = false;
        this.modificando = false;
        this.rut_encontrado = false;
        this.valores_cert_recibidos = false;
        this.cert_seleccionado = false;
        this.lista_cert_seleccionados = [];
        this.emailValido = false;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.webUrl = GLOBAL.webUrl;
        this.web = GLOBAL.web;
        this.footer = GLOBAL.footer;
        this.searchText = "";
        //cantidad de certificados seleccionados
        this.cantidadCert = 0;
        this.documentos_obligatorios = [
            // { selected: false, doc_obg_name: 'Avalúo Fiscal', doc_obg_name_id: '' },
            // { selected: false, doc_obg_name: 'Avalúo Fiscal', doc_obg_name_id: '' },
            // { selected: false, doc_obg_name: 'Avalúo Fiscal', doc_obg_name_id: '' }
            false,
            false,
            false
        ];
        this.dbx_links = [];
        this.seleccion_nameCert = "";
        this.seleccion_dire = "";
        this.seleccion_num = "";
        this.seleccion_rol = "";
        this.seleccion_cert = "";
        this.archivosSubidos = false;
        this.files = [];
        this.rowsObligatorios = [];
        this.actualSizeFiles = 0;
        this.rows1 = [{ total: 0 }];
        this.documentoNombre = '';
        this.maxSizeFiles = 75000000;
        this.spinner.show();
        this._prop.getCalles().subscribe(function (response) {
            _this.calles = response.calles;
            _this.bandera = true;
            console.log(_this.calles);
            /* console.log(response.calles) */
            _this._userService.get_valores_cert().subscribe(function (res) {
                console.log("valores", res);
                for (var i = 0; i < res.certs.length; i++) {
                    var element_1 = res.certs[i];
                    _this.valores_cert.push({
                        alias: element_1.TRAEXP_Alias,
                        nombre: element_1.TRAEXP_Tipo,
                        corvi: element_1.TRAEXP_Monto,
                        plazo: element_1.TRAEXP_DiasPlazo,
                        tipoPlazo: element_1.TRAEXP_Dia_Habil,
                        valor: formatNumber(Math.round((element_1.TRAEXP_Tipo_Moneda == "CORVI" ? (element_1.TRAEXP_corvi * res.corvi) : (element_1.TRAEXP_UTM * res.utm))), 'cl'),
                        valorNoFormat: Math.round((element_1.TRAEXP_Tipo_Moneda == "CORVI" ? (element_1.TRAEXP_corvi * res.corvi) : (element_1.TRAEXP_UTM * res.utm))),
                        estampilla: element_1.TRAEXP_Valor_Estampilla
                    });
                    _this.valores_cert_noformat.push({
                        alias: element_1.TRAEXP_Alias,
                        nombre: element_1.TRAEXP_Tipo,
                        corvi: element_1.TRAEXP_Monto,
                        plazo: element_1.TRAEXP_DiasPlazo,
                        valor: Math.round((element_1.TRAEXP_Tipo_Moneda == "CORVI" ? (element_1.TRAEXP_corvi * res.corvi) : (element_1.TRAEXP_UTM * res.utm))),
                        estampilla: element_1.TRAEXP_Valor_Estampilla
                    });
                }
                /*  console.log(this.valores_cert) */
                console.log(_this.valores_cert_noformat);
                _this.spinner.hide();
                _this.valores_cert_recibidos = true;
                // this.dialog.closeAll()
            }, function (error) {
                console.log(error);
            });
        }, function (error) {
            console.log(error);
        });
        this.rut = new FormControl("", Validators.required);
        this.dialogConfig = new MatDialogConfig();
        this.dialogConfig.disableClose = true;
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();
    }
    Solicitud_certificadosComponent.prototype.ngOnInit = function () {
        var _this = this;
        /*   this.spinner.show() */
        this.arrayItems = [];
        this.firstFormGroup = this._formBuilder.group({
            rut: ['', [Validators.required, this.rutValidator]],
            mod_solicitante: this._formBuilder.group({
                nombre: ['', [Validators.required]],
                apellido_p: [''],
                apellido_m: [''],
                calle: ['', [Validators.required]],
                num: ['', [Validators.required]],
                complemento: [''],
                telefono: [''],
                cel: ['', [Validators.required]],
                ciudad: [''],
                comuna: [''],
                email: ['', [Validators.required, Validators.email]]
            })
        });
        this.secondFormGroup = this._formBuilder.group({
            rol: this.rol,
            dir: this.dir,
            num: this.num
        });
        this.thirdFormGroup = this._formBuilder.group({});
        this.filteredOptions = this.secondFormGroup.controls.dir.valueChanges.pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        if (sessionStorage.getItem('identity-domCloud')) {
            var identityData = this._userService.getIdentity();
            this.firstFormGroup.controls['rut'].setValue(identityData.rut + '-' + identityData.dv);
            this.searchUser();
        } /* else {
            this._router.navigate(['/inicio'])
            swal({
                type: 'warning',
                text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            })
        } */
    };
    Solicitud_certificadosComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.calles.filter(function (option) { return option.toLowerCase().indexOf(filterValue) === 0; });
    };
    Solicitud_certificadosComponent.prototype.ngDoCheck = function () {
        this.segundoPaso = false;
        this.cert_seleccionado = false;
        this._changeDetector.detectChanges();
        for (var i = 0; i < this.certSelected.length; i++) {
            for (var n = 0; n < this.certSelected[i].certs.length; n++) {
                var element2 = this.certSelected[i].certs[n];
                if (element2.selected) {
                    this.cert_seleccionado = true;
                }
            }
        }
        if (this.lista_dir.value.length > 0) {
            this.segundoPaso = true;
        }
    };
    Solicitud_certificadosComponent.prototype.someFunction = function (diridx, o, item, event) {
        console.log("someFunction()");
        console.log("item", item);
        console.log("event", event);
        var dirEncontrada = false;
        if (this.certSelected.length > 0) {
            var cont = 0;
            for (var i = 0; i < this.certSelected.length; i++) {
                var element_2 = this.certSelected[i];
                if (item.rol == element_2.rol) {
                    dirEncontrada = true;
                }
                cont++;
            }
            if (cont == this.certSelected.length) {
                if (!dirEncontrada) {
                    this.certSelected.push({
                        calle: item.calle,
                        num: item.num,
                        rol: item.rol,
                        idDirec: item.info._PDI_Id_Direcc,
                        folio: item.folio,
                        certs: []
                    });
                    for (var i = 0; i < this.valores_cert.length; i++) {
                        var element_3 = this.valores_cert[i];
                        // this.documentos_obligatorios[i] = false;
                        this.certSelected[this.certSelected.length - 1].certs.push({
                            nombre: element_3.nombre,
                            alias: element_3.alias,
                            selected: false,
                            valor: element_3.valor,
                            valorNoFormat: element_3.valorNoFormat,
                            estampilla: element_3.estampilla,
                            numAsigm: ""
                        });
                    }
                }
            }
        }
        else {
            console.log("certSelected.length no es mayor a 0 item", item);
            this.certSelected.push({
                calle: item.calle,
                num: item.num,
                rol: item.rol,
                idDirec: item.info._PDI_Id_Direcc,
                folio: item.folio,
                certs: []
            });
            console.log("this.certSelected", this.certSelected);
            for (var i = 0; i < this.valores_cert.length; i++) {
                var element_4 = this.valores_cert[i];
                // this.documentos_obligatorios[i] = false;
                this.certSelected[0].certs.push({
                    nombre: element_4.nombre,
                    alias: element_4.alias,
                    selected: false,
                    valor: element_4.valor,
                    valorNoFormat: element_4.valorNoFormat,
                    estampilla: element_4.estampilla,
                    numAsigm: ""
                });
            }
        }
        console.log("this.certSelected", this.certSelected);
        if (event.source == undefined) {
            for (var i = 0; i < this.certSelected.length; i++) {
                var element_5 = this.certSelected[i];
                for (var x = 0; x < this.certSelected[i].certs.length; x++) {
                    var element2 = this.certSelected[i].certs[x];
                    if (element2.alias == "ASIGM") {
                        this.certSelected[i].certs[x].numAsigm = this.numAsig[i];
                    }
                }
            }
        }
        else {
            for (var i = 0; i < this.certSelected.length; i++) {
                var element_6 = this.certSelected[i];
                if (element_6.rol == item.rol) {
                    console.log("element.rol", element_6.rol);
                    console.log("item.rol", item.rol);
                    for (var x = 0; x < this.certSelected[i].certs.length; x++) {
                        var element2 = this.certSelected[i].certs[x];
                        if (event.source.value == element2.alias) {
                            console.log("element2.alias", element2.alias);
                            //buscar si esta seleccionado el 'CERTIFICADO DE VIVIENDA SOCIAL'
                            if (element2.alias == 'CVS') {
                                console.log("CERTIFICADO DE VIVIENDA SOCIAL SELECCIONADO");
                                // this.documentos_obligatorios[i] = event.checked;
                                this.documentos_obligatorios[i] = event.checked; //{ selected: event.checked, };
                                //ver si es el primer segundo o tercer rol
                            }
                            console.log("event.source.value", event.source.value);
                            console.log("element2.alias", element2.alias);
                            this.certSelected[i].certs[x].selected = event.checked;
                            if (element2.alias == "ASIGM") {
                                this.certSelected[i].certs[x].numAsigm = this.numAsig[i];
                            }
                        }
                    }
                }
            }
        }
        this.mostrarNum = true;
        console.log("this.documentos_obligatorios", this.documentos_obligatorios);
        console.log("this.certSelected", this.certSelected);
        console.log("this.dirs", this.dirs);
    };
    Solicitud_certificadosComponent.prototype.createItem = function () {
        return this._formBuilder.group({
            aup: false,
            cip: false,
            cnum: false,
            zn: false
        });
    };
    Solicitud_certificadosComponent.prototype.solicitar_Certificados = function () {
        // this.dialog.open(this.modal_sol_cert, this.dialogConfig)
        this.mostrar_solicitud = true;
    };
    Solicitud_certificadosComponent.prototype.cerrar_vista = function () {
        this.mostrar_solicitud = false;
        this.firstFormGroup.reset();
        this.secondFormGroup.reset();
        this.modificando = false;
        this.primerPaso = false;
        this.dirs = [];
        this.rut.reset();
    };
    Solicitud_certificadosComponent.prototype.buscar_info_sol = function () {
        var _this = this;
        this.spinner.show();
        var rutSinPuntos = this.firstFormGroup.controls.rut.value;
        if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
            rutSinPuntos = this.firstFormGroup.controls.rut.value.toString().replace(".", "");
            if (rutSinPuntos.includes(".")) {
                rutSinPuntos = rutSinPuntos.replace(".", "");
            }
            console.log("entre en el if de los puntos", rutSinPuntos);
        }
        this.continuar = false;
        this._userService.traerInfo_rut(rutSinPuntos).subscribe(function (response) {
            _this.rut_encontrado = false;
            if (response) {
                _this.info_rut = response.data;
                _this.emailValido = _this.info_rut.emailValido;
                console.log(_this.info_rut);
                console.log(_this.info_rut.email == '');
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(String(_this.info_rut.email).toLowerCase())) {
                    _this.continuar = true;
                }
                _this.firstFormGroup.patchValue({ mod_solicitante: { nombre: _this.info_rut.nombre } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { apellido_p: _this.info_rut.apellido_p } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { apellido_m: _this.info_rut.apellido_m } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { calle: _this.info_rut.calle } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { num: _this.info_rut.numero } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { complemento: _this.info_rut.complemento } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { telefono: _this.info_rut.telefono } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { cel: _this.info_rut.celular } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { ciudad: _this.info_rut.ciudad } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { comuna: _this.info_rut.comuna } });
                _this.firstFormGroup.patchValue({ mod_solicitante: { email: _this.info_rut.email } });
                _this.primerPaso = true;
                _this.rut_encontrado = true;
                _this.spinner.hide();
                _this._changeDetector.detectChanges();
            }
        }, function (error) {
            _this.spinner.hide();
            _this.modificando = true;
            _this.rut_encontrado = false;
        });
    };
    Solicitud_certificadosComponent.prototype.mod_inforut = function () {
        this.firstFormGroup.controls.mod_solicitante.setValue({
            nombre: this.info_rut.nombre ? this.info_rut.nombre : " ",
            apellido_p: this.info_rut.apellido_p ? this.info_rut.apellido_p : " ",
            apellido_m: this.info_rut.apellido_m ? this.info_rut.apellido_m : " ",
            calle: this.info_rut.calle ? this.info_rut.calle : " ",
            num: this.info_rut.numero ? this.info_rut.numero : " ",
            complemento: this.info_rut.complemento ? this.info_rut.complemento : " ",
            telefono: this.info_rut.telefono ? this.info_rut.telefono : " ",
            cel: this.info_rut.celular ? this.info_rut.celular : " ",
            ciudad: this.info_rut.ciudad ? this.info_rut.ciudad : " ",
            comuna: this.info_rut.comuna ? this.info_rut.comuna : " ",
            email: this.info_rut.email ? this.info_rut.email : " "
        });
        this.primerPaso_mod = true;
        this.primerPaso = false;
        this.modificando = true;
    };
    Solicitud_certificadosComponent.prototype.guarda_mod = function () {
        var _this = this;
        this.spinner.show();
        this._userService.save_info_mod_solicitante(this.info_rut.rut, this.firstFormGroup.controls.mod_solicitante.value).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            _this.modificando = false;
            swal({
                type: 'success',
                title: 'Guardado!',
                text: response.message,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(function () {
            }, function (dismiss) {
                if (dismiss === 'timer') {
                }
            });
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
            swal({
                type: 'error',
                title: 'Ha ocurrido un error!',
                text: error._body,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(function () {
            }, function (dismiss) {
                if (dismiss === 'timer') {
                }
            });
        });
    };
    Solicitud_certificadosComponent.prototype.registro_sol = function () {
        var _this = this;
        var rutSinPuntos = this.firstFormGroup.controls.rut.value;
        if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
            rutSinPuntos = this.firstFormGroup.controls.rut.value.toString().replace(".", "");
            if (rutSinPuntos.includes(".")) {
                rutSinPuntos = rutSinPuntos.replace(".", "");
            }
            console.log("entre en el if de los puntos", rutSinPuntos);
        }
        var userinfo = {
            rut: rutSinPuntos,
            nombre: this.firstFormGroup.controls.mod_solicitante.value.nombre,
            app: this.firstFormGroup.controls.mod_solicitante.value.apellido_p,
            apm: this.firstFormGroup.controls.mod_solicitante.value.apellido_m,
            dir: this.firstFormGroup.controls.mod_solicitante.value.calle,
            num: this.firstFormGroup.controls.mod_solicitante.value.num,
            dircom: this.firstFormGroup.controls.mod_solicitante.value.complemento,
            telefono: this.firstFormGroup.controls.mod_solicitante.value.telefono,
            celular: this.firstFormGroup.controls.mod_solicitante.value.cel,
            ciudad: this.firstFormGroup.controls.mod_solicitante.value.ciudad,
            comuna: this.firstFormGroup.controls.mod_solicitante.value.comuna,
            email: this.firstFormGroup.controls.mod_solicitante.value.email,
        };
        console.log(userinfo);
        this._userService.save_solicitante(userinfo).subscribe(function (response) {
            console.log(response);
            swal({
                type: 'success',
                title: 'Registrado!',
                text: response.message,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(function () {
            }, function (dismiss) {
                if (dismiss === 'timer') {
                }
            });
            _this.buscar_info_sol();
            _this.modificando = false;
        }, function (error) {
            console.log(error);
            swal({
                type: 'error',
                title: 'Ha ocurrido un error!',
                text: error._body,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(function () {
            }, function (dismiss) {
                if (dismiss === 'timer') {
                }
            });
        });
    };
    Solicitud_certificadosComponent.prototype.cancelar_mod = function () {
        if (this.rut_encontrado) {
            this.modificando = false;
            this.primerPaso_mod = false;
            this.primerPaso = true;
        }
        else {
            this.modificando = false;
            this.rut_encontrado = false;
            this.primerPaso = false;
            this.primerPaso_mod = false;
        }
    };
    Solicitud_certificadosComponent.prototype.buscar_info_propiedad_rol = function () {
        var _this = this;
        this.spinner.show();
        this._userService.traerInfo_propiedad_rol(this.secondFormGroup.controls.rol.value).subscribe(function (response) {
            console.log(response);
            if (response.status == "error") {
                _this.spinner.hide();
                _this.secondFormGroup.controls.dir.setValue("");
                _this.secondFormGroup.controls.num.setValue("");
                _this.secondFormGroup.controls.rol.setValue("");
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: response.message,
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
            }
            else if (response.status == "bloqueado") {
                _this.spinner.hide();
                _this.secondFormGroup.controls.dir.setValue("");
                _this.secondFormGroup.controls.num.setValue("");
                _this.secondFormGroup.controls.rol.setValue("");
                swal({
                    type: 'warning',
                    title: 'El ROL ingresado se encuentra bloqueado.',
                    text: response.message,
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
            }
            else {
                _this.spinner.hide();
                var rol_yaExiste = false;
                if (_this.dirs.length <= 2) {
                    for (var i = 0; i < _this.dirs.length; i++) {
                        if (_this.dirs[i].rol == response.rol) {
                            rol_yaExiste = true;
                        }
                    }
                    if (!rol_yaExiste) {
                        if (response.dirs.length > 1) {
                            _this.dirrecciones = response;
                            _this.dialog.open(_this.direccionesDialog, { disableClose: true });
                        }
                        else {
                            var dir = {
                                calle: response.dirs[0].calle,
                                num: response.dirs[0].num,
                                dirComp: response.dirs[0].direcCompleta,
                                cip: response.cip,
                                cnum: response.cnum,
                                aup: response.aup,
                                rol: response.rol,
                                folio: response.folio,
                                info: response.info
                            };
                            console.log("dir elegid=asdaffdafs", dir);
                            _this.dirs.push(dir);
                            _this.lista_dir.next(_this.dirs);
                            _this._changeDetector.detectChanges();
                            _this.secondFormGroup.controls.dir.setValue("");
                            _this.secondFormGroup.controls.num.setValue("");
                            _this.secondFormGroup.controls.rol.setValue("");
                            if (_this.dirs.length > 0) {
                                _this.segundoPaso = true;
                            }
                            console.log(_this.lista_dir);
                        }
                    }
                    else {
                        _this.secondFormGroup.controls.dir.setValue("");
                        _this.secondFormGroup.controls.num.setValue("");
                        _this.secondFormGroup.controls.rol.setValue("");
                        swal({
                            type: 'warning',
                            title: 'Atención!',
                            text: 'El rol ingresado ya esta agregado',
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500
                        }).then(function () {
                        }, function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        });
                    }
                }
                else {
                    _this.spinner.hide();
                    _this.secondFormGroup.controls.dir.setValue("");
                    _this.secondFormGroup.controls.num.setValue("");
                    _this.secondFormGroup.controls.rol.setValue("");
                    _this.snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                        duration: 2000,
                    });
                }
            }
        }, function (error) {
            _this.spinner.hide();
            _this.secondFormGroup.controls.dir.setValue("");
            _this.secondFormGroup.controls.num.setValue("");
            _this.secondFormGroup.controls.rol.setValue("");
            swal({
                type: 'error',
                title: 'Ha ocurrido un error!',
                text: error._body,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(function () {
            }, function (dismiss) {
                if (dismiss === 'timer') {
                }
            });
        });
    };
    Solicitud_certificadosComponent.prototype.buscar_info_propiedad_direccion = function () {
        var _this = this;
        this.spinner.show();
        var calle = "";
        calle = this.secondFormGroup.controls.dir.value;
        calle.toUpperCase();
        this._userService.traerInfo_propiedad_direccion(calle.toUpperCase(), this.secondFormGroup.controls.num.value).subscribe(function (response) {
            _this.spinner.hide();
            console.log("entre en buscar por direccion", response);
            var dir_yaExiste = false;
            if (response.status == "error") {
                _this.secondFormGroup.controls.dir.setValue("");
                _this.secondFormGroup.controls.num.setValue("");
                _this.secondFormGroup.controls.rol.setValue("");
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: response.message,
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
            }
            else if (response.status == "bloqueado") {
                _this.spinner.hide();
                _this.secondFormGroup.controls.dir.setValue("");
                _this.secondFormGroup.controls.num.setValue("");
                _this.secondFormGroup.controls.rol.setValue("");
                swal({
                    type: 'warning',
                    title: 'El ROL ingresado se encuentra bloqueado.',
                    text: response.message,
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
            }
            else {
                _this.spinner.hide();
                var rol_yaExiste = false;
                if (_this.dirs.length <= 2) {
                    for (var i = 0; i < _this.dirs.length; i++) {
                        if (_this.dirs[i].rol == response.rol) {
                            rol_yaExiste = true;
                        }
                    }
                    if (!rol_yaExiste) {
                        if (response.dirs.length > 1) {
                            _this.dirrecciones = response;
                            _this.dialog.open(_this.direccionesDialog, { disableClose: true });
                        }
                        else {
                            var dir = {
                                calle: response.dirs[0].calle,
                                num: response.dirs[0].num,
                                dirComp: response.dirs[0].direcCompleta,
                                cip: response.cip,
                                cnum: response.cnum,
                                aup: response.aup,
                                rol: response.rol,
                                folio: response.folio,
                                info: response.info
                            };
                            _this.dirs.push(dir);
                            _this.lista_dir.next(_this.dirs);
                            _this._changeDetector.detectChanges();
                            _this.secondFormGroup.controls.dir.setValue("");
                            _this.secondFormGroup.controls.num.setValue("");
                            _this.secondFormGroup.controls.rol.setValue("");
                            if (_this.dirs.length > 0) {
                                _this.segundoPaso = true;
                            }
                            console.log(_this.lista_dir);
                        }
                    }
                    else {
                        _this.secondFormGroup.controls.dir.setValue("");
                        _this.secondFormGroup.controls.num.setValue("");
                        _this.secondFormGroup.controls.rol.setValue("");
                        swal({
                            type: 'warning',
                            title: 'Atención!',
                            text: 'El rol ingresado ya esta agregado',
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500
                        }).then(function () {
                        }, function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        });
                    }
                }
                else {
                    _this.spinner.hide();
                    _this.secondFormGroup.controls.dir.setValue("");
                    _this.secondFormGroup.controls.num.setValue("");
                    _this.secondFormGroup.controls.rol.setValue("");
                    _this.snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                        duration: 2000,
                    });
                }
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
            _this.secondFormGroup.controls.dir.setValue("");
            _this.secondFormGroup.controls.num.setValue("");
            _this.secondFormGroup.controls.rol.setValue("");
            swal({
                type: 'error',
                title: 'Ha ocurrido un error!',
                text: error._body,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(function () {
            }, function (dismiss) {
                if (dismiss === 'timer') {
                }
            });
        });
    };
    Solicitud_certificadosComponent.prototype.insertarDir = function () {
        var rol_yaExiste = false;
        if (this.dirs.length <= 2) {
            for (var i = 0; i < this.dirs.length; i++) {
                if (this.dirs[i].rol == this.dirrecciones.rol) {
                    rol_yaExiste = true;
                }
            }
            if (!rol_yaExiste) {
                console.log(this.dirSeleccionada);
                console.log("direccionesss", this.dirSeleccionada);
                var dir = {
                    calle: this.dirSeleccionada.calle,
                    num: this.dirSeleccionada.num,
                    dirComp: this.dirSeleccionada.direcCompleta,
                    rol: this.dirSeleccionada.rol,
                    folio: this.dirSeleccionada.folio,
                    info: this.dirrecciones.info,
                };
                this.dirs.push(dir);
                this.lista_dir.next(this.dirs);
                console.log(this.lista_dir);
                this._changeDetector.detectChanges();
                this.secondFormGroup.controls.dir.setValue("");
                this.secondFormGroup.controls.num.setValue("");
                this.secondFormGroup.controls.rol.setValue("");
                if (this.dirs.length > 0) {
                    this.segundoPaso = true;
                }
                this.dialog.closeAll();
            }
            else {
                this.dialog.closeAll();
                this.secondFormGroup.controls.dir.setValue("");
                this.secondFormGroup.controls.num.setValue("");
                this.secondFormGroup.controls.rol.setValue("");
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'El rol ingresado ya esta agregado',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
            }
        }
        else {
            this.dialog.closeAll();
            this.spinner.hide();
            this.secondFormGroup.controls.dir.setValue("");
            this.secondFormGroup.controls.num.setValue("");
            this.secondFormGroup.controls.rol.setValue("");
            this.snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                duration: 2000,
            });
        }
    };
    Solicitud_certificadosComponent.prototype.eliminar_direccion = function (i, item) {
        console.log(i);
        console.log(item);
        this.segundoPaso = false;
        console.log(this.lista_dir);
        var filter = this.dirs.filter(function (vale, index, arr) {
            return index != i;
        });
        if (this.certSelected.length > 0) {
            for (var i_1 = 0; i_1 < this.certSelected.length; i_1++) {
                var element_7 = this.certSelected[i_1];
                if (element_7.rol == item.rol) {
                    this.certSelected.splice(i_1, 1);
                }
            }
        }
        if (this.lista_dir.value.length > 0) {
            this.segundoPaso = true;
        }
        this.dirs = filter;
        this.lista_dir.next(this.dirs);
        this._changeDetector.detectChanges();
    };
    Solicitud_certificadosComponent.prototype.cerrar_dialog = function () {
        this.dialog.closeAll();
        this.primerPaso = false;
        this.segundoPaso = false;
        this.tercerPaso = false;
        this.info_rut = [];
        this.dirs = [];
    };
    Solicitud_certificadosComponent.prototype.calcular_total = function () {
        this.cantidadCert = 0;
        console.log(this.certSelected);
        this.valor_total_cert = 0;
        for (var i = 0; i < this.certSelected.length; i++) {
            for (var x = 0; x < this.certSelected[i].certs.length; x++) {
                var element_8 = this.certSelected[i].certs[x];
                if (element_8.selected) {
                    this.valorTotalEstampilla = element_8.estampilla;
                    this.cantidadCert++;
                    console.log("entre en calcular", element_8);
                    if (element_8.alias == "ASIGM") {
                        this.valorOnlyCert = this.valorOnlyCert + (element_8.valorNoFormat * this.numAsig[i]);
                        this.valor_total_cert = this.valor_total_cert + element_8.estampilla + (element_8.valorNoFormat * this.numAsig[i]);
                    }
                    else {
                        this.valor_total_cert = this.valor_total_cert + element_8.estampilla + element_8.valorNoFormat;
                        this.valorOnlyCert = this.valorOnlyCert + element_8.valorNoFormat;
                    }
                }
            }
        }
        console.log("Valor total", this.valor_total_cert);
        this.mostrar_total2 = formatNumber(this.valor_total_cert, 'cl');
        this.mostrar_total = this.valor_total_cert;
        console.log(this.mostrar_total);
    };
    Solicitud_certificadosComponent.prototype.toLobby = function () {
        this._router.navigateByUrl('/');
        this.dialog.closeAll();
    };
    Solicitud_certificadosComponent.prototype.docId = function () {
        var text = '';
        var possible = '0123456789';
        for (var i = 0; i < 8; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    };
    Solicitud_certificadosComponent.prototype.closeTab = function () {
        window.close();
    };
    Solicitud_certificadosComponent.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var now;
            var _this = this;
            return __generator(this, function (_a) {
                this.pagando = true;
                console.log("entre en ell onsubmit");
                this.spinner.show();
                now = moment(new Date()).format('YYYY-MM-DD').split("-");
                console.log(this.dirs);
                this.id_carro = this.docId();
                this.carro_deptos = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n        <soapenv:Envelope xmlns:soapenv=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:tem=\"http://tempuri.org/\">\n        <soapenv:Header/>\n        <soapenv:Body>\n        <tem:Traer_IngDeptos>\n        <tem:Codigo_Area>1</tem:Codigo_Area>\n        <tem:Ano_Proceso>" + now[0] + "</tem:Ano_Proceso>\n        <!--Optional:-->\n        <tem:Item_Pago>5</tem:Item_Pago>\n        <!--Optional:-->\n        <tem:CodigoMunicipalidad>0</tem:CodigoMunicipalidad>\n        </tem:Traer_IngDeptos>\n        </soapenv:Body>\n        </soapenv:Envelope>";
                this._userService.casWsConsumo(this.mostrar_total, this.info_rut, this.carro_deptos).subscribe(function (res) {
                    console.log(res);
                    if (res.code == "200") {
                        _this._userService.casWsConsumoCuentas(_this.mostrar_total, _this.info_rut, res.resp, _this.valorOnlyCert, _this.valorTotalEstampilla, _this.cantidadCert).subscribe(function (resCuentas) {
                            console.log(resCuentas);
                            if (resCuentas.code == "200") {
                                _this._userService.casWsCreateGiro(_this.mostrar_total, _this.mostrar_total2, _this.info_rut, resCuentas.resp, resCuentas.item_pago, _this.certSelected, _this.observacion.value, _this.dbx_links).subscribe(function (respGiro) {
                                    _this.spinner.hide();
                                    swal({
                                        type: 'success',
                                        title: 'Todo listo!',
                                        text: "Para continuar debe ingresar sus datos en el portal, una vez realizado el pago, le llegara un correo de confirmación dentro de los próximos 10 minutos.",
                                        confirmButtonColor: '#3F51B5',
                                        confirmButtonText: 'Aceptar',
                                        onClose: function () {
                                            _this._router.navigate(["/inicio"]);
                                            window.open("https://ww16.e-com.cl/Pagos/PagosVariosv3/?id=70", "_blank");
                                        }
                                    }).then(function () {
                                    }, function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    });
                                }, function (error) {
                                    console.log(error);
                                    swal({
                                        type: 'warning',
                                        title: 'Atención!',
                                        text: "Ha ocurrido un error",
                                        confirmButtonColor: '#3F51B5',
                                        confirmButtonText: 'Aceptar',
                                        timer: 3500
                                    }).then(function () {
                                    }, function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    });
                                });
                            }
                            else if (res.code == "500") {
                                console.log(resCuentas);
                                swal({
                                    type: 'warning',
                                    title: 'Atención!',
                                    text: "Ha ocurrido un error",
                                    confirmButtonColor: '#3F51B5',
                                    confirmButtonText: 'Aceptar',
                                    timer: 3500
                                }).then(function () {
                                }, function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                });
                            }
                        }, function (error) {
                            console.log(error);
                            swal({
                                type: 'warning',
                                title: 'Atención!',
                                text: "Ha ocurrido un error",
                                confirmButtonColor: '#3F51B5',
                                confirmButtonText: 'Aceptar',
                                timer: 3500
                            }).then(function () {
                            }, function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            });
                        });
                    }
                    else if (res.code == "500") {
                        swal({
                            type: 'warning',
                            title: 'Atención!',
                            text: "Ha ocurrido un error",
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500
                        }).then(function () {
                        }, function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        });
                    }
                }, function (error) {
                    console.log(error);
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: "Ha ocurrido un error",
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(function () {
                    }, function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    Solicitud_certificadosComponent.prototype.finalizarBTN = function () {
        this._router.navigate(["/"]);
        this.dialog.closeAll();
    };
    Solicitud_certificadosComponent.prototype.verObligatorios = function (cert) {
        console.log("cert", cert);
        // console.log("cert.TRAEXP_Oblig", cert.TRAEXP_Oblig)
        // var obligatorios;
        // for (let index = 0; index < cert.TRAEXP_Oblig.length; index++) {
        //   const element = cert.TRAEXP_Oblig[index];
        //   // console.log("obligatorios",obligatorios)
        //   obligatorios = obligatorios == undefined ?
        //     (' <br><div style="text-align: justify; padding: 0 1em 0 1em" >  <i class="material-icons">description</i>' + element.nombre + '</div> <br>') :
        //     (obligatorios + '<div style="text-align: justify; padding: 0 1em 0 1em" > <i class="material-icons">description</i>' + element.nombre + '</div> <br>');
        //   console.log("obligatorios", obligatorios)
        // }
        // swal({
        //     type: "info",
        //     title: "Documentos Obligatorios ",
        //     text: '<br>( ' + cert.TRAEXP_Tipo_Sanitizado + ' )<br>' + obligatorios,
        //     showConfirmButton: true,
        //     confirmButtonText: 'Aceptar',
        //     allowOutsideClick: false
        //   })
        swal({
            type: "info",
            title: "Documentos Obligatorios ",
            text: '<br>Certificado de Avalúo Fiscal Detallado<br>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        });
    };
    Solicitud_certificadosComponent.prototype.capitalize = function (word) {
        return word[0].toUpperCase() + word.slice(1);
    };
    Solicitud_certificadosComponent.prototype.llenarTabla = function (dir) {
        console.log("llenarTabla(dir) dir", dir);
        this.cargando = true;
        this.rowsObligatorios = [];
        this.files = [];
        this.actualSizeFiles = 0;
        console.log("dir", dir);
        console.log("this.certSelected", this.certSelected);
        var contador = 0;
        this.rowsObligatorios.push({
            id: contador,
            name: 'Certificado de Avalúo Fiscal Detallado',
        });
        console.log('this.rowsObligatorios.find(element=>element.name == obligatorio.nombre)', this.rowsObligatorios.find(function (element) { return element.name.includes("Certificado de Avalúo Fiscal Detallado"); }));
        console.log("this.rowsObligatorios", this.rowsObligatorios);
        console.log("this.seleccion_cert", this.seleccion_cert);
        var archivos = localStorage.getItem("archivos_marcados");
        if (archivos) {
            var subidos = { "archivosSubidos": false };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
        }
        this.cargando = false;
    };
    Solicitud_certificadosComponent.prototype.confirmarAdjuntarNuevos = function () {
        console.log("Se subiran nuevos archivos");
        this.dialogRef = this.dialog.open(this.modalDocumentos, {
            id: "modalDocumentos2",
            disableClose: true,
            width: "60%"
        });
    };
    Solicitud_certificadosComponent.prototype.adjuntar = function (dir) {
        console.log("dir", dir);
        this.seleccion_dire = this.capitalize((dir.dirComp).toLowerCase());
        // this.seleccion_num = dir.num
        this.seleccion_rol = dir.rol;
        this.llenarTabla(dir);
        this.dialogRef = this.dialog.open(this.modalDocumentos, {
            id: "modalDocumentos",
            disableClose: true,
            width: "60%"
        });
    };
    Solicitud_certificadosComponent.prototype.limpiarDocs = function () {
        this.rowsObligatorios = [];
        this.files = [];
        this.peso = 0;
        this.seleccion_dire = '';
        this.seleccion_num = '';
        this.seleccion_rol = '';
        this.seleccion_cert = '';
        this.seleccion_nameCert = '';
    };
    Solicitud_certificadosComponent.prototype.uploadAllfiles = function () {
        var _this = this;
        console.log("uploadAllfiles()");
        var formType = 'Certificado-' + this.seleccion_cert.toUpperCase() + "-ROL:'" + this.seleccion_rol + "'";
        this.spinner.show();
        // this.onActivate()
        this._userService.uploadFiles(this.files, formType).subscribe(function (response) {
            console.log("uploadFiles response", response);
            _this.spinner.hide();
            var subidos = { "archivosSubidos": true };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
            var alert = { icon: 'success', text: '', title: '' };
            // this.onActivate()
            if (response.code == 99 && response.url) {
                alert.icon = 'success';
                alert.text = '<p>Puedes revisar una vez más tus documentos, usa el siguiente link <br><br> <a mat-stroked-button href="' + response.url + '" style="text-decoration=none" target="_blank"><strong>Descarga tus documentos<strong></a><br><br><br></p>';
                alert.title = 'Archivos cargados';
                console.log("response.url", response.url);
                for (var index = 0; index < _this.dirs.length; index++) {
                    var dire = _this.dirs[index];
                    // if (this.documentos_obligatorios[index]) //si documentos_obligatorios y en else poner subido true
                    // {
                    //     console.log(`index ${index} tiene documentos obligatorios por subir`)
                    // } else {
                    //     console.log(`index ${index} no tiene documentos obligatorios por subir`)
                    // }
                    console.log("this.seleccion_dire", _this.seleccion_dire);
                    console.log("dire.dirComp", dire.dirComp);
                    console.log("this.seleccion_rol", _this.seleccion_rol);
                    console.log("dire.rol", dire.rol);
                    if ((_this.seleccion_dire).toUpperCase() == dire.dirComp.toUpperCase()
                        // && this.seleccion_num == dire.num
                        && _this.seleccion_rol.toUpperCase() == dire.rol.toUpperCase()) {
                        //validar que no falte algun archivo
                        dire.url = response.url;
                        dire.obligatorios_subidos = true;
                        dire.subido = true;
                        // for (let i = 0; i < dire.cert.length; i++) {
                        //     const certificado = dire.cert[i]
                        //     // console.log("this.seleccion_cert", this.seleccion_cert)
                        //     console.log("certificado.name_id", certificado.name_id)
                        //     // if (certificado.name_id == this.seleccion_cert) {
                        //     certificado.url = response.url//no importa que no recorra uno por uno pq es un paquete con todos los archivos del certificado
                        //     certificado.subido = true
                        //     // }
                        //     dire.obligatorios_subidos = true;
                        // }
                        // for (let index = 0; index < this.documentos_obligatorios.length; index++) {
                        //     const element = this.documentos_obligatorios[index];
                        //     dire.url = response.url
                        //     dire.obligatorios_subidos = true;
                        //     dire.subido = true
                        // }
                    }
                    if (_this.dirs.length == index + 1) {
                        console.log(_this.dirs[index]);
                        _this.dialog.closeAll();
                        _this.limpiarDocs();
                        _this.validarDocs();
                    }
                }
                _this.archivosSubidos = true;
                console.log("this.dirs", _this.dirs);
            }
            else if (response.code == 98) {
                alert.icon = 'error';
                alert.text = '<p>No se adjuntaron documentos</p>';
                alert.title = 'Archivos no cargados';
            }
            else if (response.code == 97) {
                alert.icon = 'error';
                alert.text = '<p>No se adjuntaron documentos</p>';
                alert.title = 'Archivos no cargados';
            }
            else if (response.code == 96) {
                alert.icon = 'error';
                alert.text = '<p>Archivos no permitidos</p>';
                alert.title = 'Archivos no cargados';
            }
            else {
                alert.icon = 'error';
                alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>';
                alert.title = 'Archivos no cargados';
            }
            swal({
                icon: alert.icon,
                title: alert.title,
                text: alert.text,
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            }).then(function () {
                window.scrollTo(0, document.body.scrollHeight);
            });
        }, function (error) {
            _this.spinner.hide();
            console.log("un error", error);
            var subidos = { "archivosSubidos": true };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
            swal({
                icon: 'error',
                title: 'Error al subir documentación',
                text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            }).then(function () {
                window.scrollTo(0, document.body.scrollHeight);
            });
        });
    };
    Solicitud_certificadosComponent.prototype.handleFileInput2 = function (files, row) {
        console.log("handleFileInput2()");
        console.log("files", files);
        console.log("row", row);
        var file;
        file = files.item(0);
        if (row.id || row.id == 0) {
            for (var index = 0; index < this.rowsObligatorios.length; index++) {
                if (this.rowsObligatorios[index].id == row.id) {
                    this.nombreArchivo = files.item(0).name;
                    var peso = (files.item(0).size / 1000000) + ' MB';
                    this.rowsObligatorios[index].archivo = this.nombreArchivo;
                    this.rowsObligatorios[index].peso = peso;
                    this.rowsObligatorios[index].newAttached = false;
                    this.files[index] = ({ name: this.rowsObligatorios[index].name, doc: file });
                }
            }
        }
        else {
            this.archivoCargado = files.item(0);
            if (files.item(0).name && this.documentoNombre != '') {
                this.btnAccept = true;
                var actualRow = localStorage.getItem("adjuntos");
                this.nombreArchivo = files.item(0).name;
                this.files[this.rowsObligatorios.length] = ({ name: this.documentoNombre, doc: file });
                this.peso = (files.item(0).size / 1000000) + ' MB';
            }
        }
        this.actualSizeFiles = this.actualSizeFiles + files.item(0).size;
        this.rows1[0].total = this.actualSizeFiles;
        this.rows1 = this.rows1.slice();
        //check max size file
        this.checksSize(this.files.length - 1);
        this.revisarTabla();
    };
    Solicitud_certificadosComponent.prototype.validarDocs = function () {
        console.log("validarDocs()");
        console.log("this.dirs", this.dirs);
        var docsSubidos = true;
        for (var i = 0; i < this.dirs.length; i++) {
            var direccion = this.dirs[i];
            console.log("this.dirs i", i);
            console.log("direccion.subido", direccion.subido);
            if (this.documentos_obligatorios[i]) //si documentos_obligatorios y en else poner subido true
             {
                console.log("la direccion index " + i + " tiene documentos obligatorios por subir");
                if (!direccion.subido) {
                    console.log(i + " tiene documentos obligatorios por subir a\u00FAn");
                    docsSubidos = false; //si en algun momento queda false no deja pasar
                }
                this.dbx_links[i] = this.dirs[i].url;
            }
            else {
                console.log("la direccion index " + i + " no tiene documentos obligatorios por subir");
            }
        }
        this.obligatorios = docsSubidos;
        console.log("dbx_links", this.dbx_links);
        console.log("docSubidos", docsSubidos);
        console.log("obligatorios", this.obligatorios);
    };
    Solicitud_certificadosComponent.prototype.checksSize = function (index) {
        if (index === void 0) { index = null; }
        if (this.actualSizeFiles > this.maxSizeFiles) {
            this.deleteFile2(index);
        }
    };
    Solicitud_certificadosComponent.prototype.revisarTabla = function () {
        var bandera = true;
        this.pase = false;
        /*    console.log("revisando tabla", this.rows) */
        for (var tabla = 0; tabla < this.rowsObligatorios.length; tabla++) {
            /*    console.log("Index ", tabla, "bandera ", bandera) */
            if (!this.rowsObligatorios[tabla].archivo || this.rowsObligatorios[tabla].archivo == "") {
                bandera = false;
            }
            if ((tabla + 1) == this.rowsObligatorios.length) {
                /*   console.log("Recorri la tabla", bandera) */
                if (bandera == true) {
                    this.pase = true;
                    /*   console.log(this.pase) */
                }
            }
        }
    };
    Solicitud_certificadosComponent.prototype.deleteFile2 = function (row) {
        var zip = localStorage.getItem("ZipURL");
        /*  console.log(zip) */
        if (zip) {
            var subidos = { "archivosSubidos": true };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
        }
        else {
            var subidos = { "archivosSubidos": false };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
        }
        /* console.log(row) */
        this.rowsObligatorios.splice(row.id, 1);
        this.files.splice(row.id, 1);
        this.clearSize();
    };
    Solicitud_certificadosComponent.prototype.clearSize = function () {
        this.actualSizeFiles = 0;
        /* console.log(this.files) */
        for (var index = 0; index < this.files.length; index++) {
            var element_9 = this.files[index];
            if (element_9) {
                this.actualSizeFiles = this.actualSizeFiles + element_9.doc.size;
            }
        }
        //check max size file
        this.checksSize(this.files.length - 1);
    };
    Solicitud_certificadosComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.dispatch(new FormActions.FormUpdate('0', ''));
                        sessionStorage.removeItem("identity-domCloud");
                        sessionStorage.removeItem("token-domCloud");
                        return [4 /*yield*/, this.claveUnicaService.logoutClaveUnica()];
                    case 1:
                        response = _a.sent();
                        console.log('Deslogeo exitoso:', response);
                        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
                            duration: 3000,
                        });
                        this.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    Solicitud_certificadosComponent.prototype.openPerfil = function () {
        this.dialog.open(PerfilComponent);
    };
    Solicitud_certificadosComponent.prototype.back = function () {
        this._router.navigate(['/inicio']);
    };
    Solicitud_certificadosComponent.prototype.searchUser = function () {
        var _this = this;
        /* Buscar si existe en fm */
        var identityData = this._userService.getIdentity();
        var rut = identityData.rut + identityData.dv;
        this._userService.buscarUsuario(rutClean(rut)).subscribe(function (response) {
            console.log(response);
            if (response.message) {
                _this.spinner.hide();
                console.log(response);
            }
            if (response.register) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
            if (response.update) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    return Solicitud_certificadosComponent;
}());
export { Solicitud_certificadosComponent };
